import React from "react";
import { useLoaderData } from "react-router";
import TwoColumnLayout from "layout/TwoColumnLayout";
import NewInvoiceV1FromShowEditSection from "./NewInvoiceV1FromShowEditSection";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";

export const AppNewInvoiceFromShow = () => {
  const viewModel = useLoaderData<server.viewmodel.ShowNewDocumentFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <NewInvoiceV1FromShowEditSection viewModel={viewModel} />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <GeneralOptionsPanel
        data={viewModel.optionsPanel}
        links={[{ text: RESX.Buttons.ListView, visible: true, href: viewModel.listUrl }]}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
};

export default AppNewInvoiceFromShow;
